import React from "react";
import ExpenseCategoriesContainer from "../../containers/ExpenseCategories";

function ExpenseCategories(props) {
  return <ExpenseCategoriesContainer {...props} />;
}

export default ExpenseCategories;
